export enum LocalStorageKeys {
  AUTH_TOKEN = 'work-hours:auth:token',
  LOGGED_USER = 'work-hours:auth:user',
  CASH_FLOW = 'work-hours:cash-flow',
  ALLOWED_SOURCE = 'work-hours:allowed-source',
  USER_VALIDATORS = 'work-hours:user-validator',
}
